// Amarja Hills · NRI Legacy Estate — trimmed content data (visual-first)
// Numbers are illustrative and displayed with disclaimers on-page.

export const NRI_SITE = {
  metaTitle: "Luxury Land Investment in India for NRIs | Amarja Hills",
  metaDescription:
    "Discover an exclusive 500-acre luxury hill estate near Mumbai. Designed for global Indians seeking legacy, lifestyle and long-term wealth creation.",
  brochureUrl: "/brochure/Amarja-Global-Investor-Brochure.pdf",
};

// Compact 4-item strip — replaces the old 8-card verbose "Why NRIs Invest"
export const WHY_STRIP = [
  { label: "Legacy Asset" },
  { label: "INR Anchor" },
  { label: "Rare Scarcity" },
  { label: "A Home to Return To" },
];

export const PERFORMANCE_STATS = [
  { value: 18, suffix: "%", label: "Historical Appreciation", caption: "5-year average" },
  { value: 20, suffix: "%", label: "Projected Growth", caption: "Illustrative 5-year potential" },
  { value: 9, suffix: "%", label: "Rental Potential", caption: "Illustrative managed yield" },
];

export const CURRENCIES = [
  { code: "USD", symbol: "$", perAcreInr: 22500000, label: "US Dollar" },
  { code: "GBP", symbol: "£", perAcreInr: 22500000, label: "British Pound" },
  { code: "AED", symbol: "AED", perAcreInr: 22500000, label: "UAE Dirham" },
  { code: "SGD", symbol: "S$", perAcreInr: 22500000, label: "Singapore Dollar" },
  { code: "CAD", symbol: "C$", perAcreInr: 22500000, label: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", perAcreInr: 22500000, label: "Australian Dollar" },
  { code: "EUR", symbol: "€", perAcreInr: 22500000, label: "Euro" },
  { code: "INR", symbol: "₹", perAcreInr: 22500000, label: "Indian Rupee" },
];

export const FX_TO_INR = {
  USD: 84, GBP: 106, AED: 23, SGD: 62, CAD: 60, AUD: 55, EUR: 91, INR: 1,
};

// Cinematic showcase — auto-advances (like the main site's CompletedProjects)
export const SHOWCASE = [
  { img: "/img/projects/p1.jpg", caption: "The Farmhouse Project" },
  { img: "/img/projects/p2.jpg", caption: "Casa Lonavala" },
  { img: "/img/projects/p3.jpg", caption: "The Chalet House" },
  { img: "/img/projects/p5.jpg", caption: "Casa Colonial" },
  { img: "/img/projects/p7.jpg", caption: "Villa Mirador" },
  { img: "/img/projects/p9.jpg", caption: "Casa Sereno" },
  { img: "/img/projects/p11.jpg", caption: "The Lake House" },
];

// Full-bleed cinematic drone slider (8 slides)
export const CINEMATIC = [
  { img: "/img/site/drone1.jpg", title: "500 Acres", sub: "Contiguous. Private. Gated." },
  { img: "/img/site/drone3.jpg", title: "The Sahyadri", sub: "Hill air, forest cover, mist." },
  { img: "/img/golf.png", title: "Private Golf", sub: "Coming soon." },
  { img: "/img/site/drone4.jpg", title: "Pawna Lake", sub: "On-estate frontage." },
  { img: "/img/clubhouse.png", title: "Members Club", sub: "Discreet, curated, yours." },
  { img: "/img/site/drone5.jpg", title: "Sunrise Ridge", sub: "East-facing, first light." },
  { img: "/img/helipad.png", title: "Helipad", sub: "Mumbai · 40 minutes." },
  { img: "/img/wellness.png", title: "Wellness", sub: "Forest-view spa & retreat." },
];

// Trimmed to essence — 6 rows
export const WEALTH_COMPARE = [
  { attribute: "Land Ownership", apartment: "Undivided share", estate: "Full title to your land" },
  { attribute: "Scarcity", apartment: "Replicable supply", estate: "Finite hill acreage" },
  { attribute: "Privacy", apartment: "Shared walls", estate: "Private, gated, forested" },
  { attribute: "Custom Villa", apartment: "Not possible", estate: "Your architect, your vision" },
  { attribute: "Inheritance", apartment: "Depreciating structure", estate: "Land appreciates across generations" },
  { attribute: "Exclusivity", apartment: "One of many", estate: "One of a limited few" },
];

export const MAP_POINTS = [
  { label: "Mumbai", detail: "99 km · 2h", type: "city" },
  { label: "Pune", detail: "49 km · 1h", type: "city" },
  { label: "Navi Mumbai Airport", detail: "88 km · 2025", type: "airport" },
  { label: "Pawna Lake", detail: "On-estate", type: "lake" },
  { label: "Expressway", detail: "12 km", type: "road" },
  { label: "Helipad", detail: "On-site", type: "helipad" },
];

// Lifestyle bento — 6 cards (was 9), image-first
export const LIFESTYLE = [
  { title: "Private Golf", img: "/img/golf.png" },
  { title: "The Clubhouse", img: "/img/clubhouse.png" },
  { title: "Spa & Wellness", img: "/img/spa.png" },
  { title: "Equestrian", img: "/img/equestrian.png" },
  { title: "Private Helipad", img: "/img/helipad.png" },
  { title: "Lake Frontage", img: "/img/site/drone1.jpg" },
];

// Trimmed to a single sentence — dignity, not marketing
export const TESTIMONIALS = [
  { initial: "R", name: "Rajiv M.", city: "Dubai · UAE", quote: "A legacy holding my children will inherit with pride." },
  { initial: "P", name: "Priya S.", city: "London · UK", quote: "The team ran everything from London. Effortless." },
  { initial: "A", name: "Arjun R.", city: "New York · USA", quote: "A private hill acreage two hours from Mumbai — that is a very short list." },
  { initial: "M", name: "Meera K.", city: "Singapore", quote: "The calibre of INR asset we recommend to our own principals." },
  { initial: "V", name: "Vikram P.", city: "Toronto · Canada", quote: "Uncommon care from first call to registration." },
  { initial: "S", name: "Sanjana T.", city: "Sydney · Australia", quote: "The balance of enjoyment and yield — that sold us." },
];

// 5 essential questions, tightened answers
export const FAQ = [
  { q: "Can NRIs and OCIs purchase land here?", a: "Yes. Under current RBI/FEMA guidelines NRIs and OCIs may purchase non-agricultural land in India. All plots at Amarja Hills are fully NA with clear title." },
  { q: "Can I purchase remotely, from abroad?", a: "Yes. Live drone tours, digital documentation and notarised POA allow you to complete the transaction from your home country." },
  { q: "Will you build and manage my villa?", a: "Yes. In-house architects deliver your build turnkey. Once ready, our team can manage caretaking, security and optional luxury short-stay rentals." },
  { q: "What taxes apply to my purchase and sale?", a: "Stamp duty and registration apply at purchase; capital gains rules apply on sale, with defined NRI provisions. Our empanelled advisors will walk you through your situation." },
  { q: "Can my children inherit the land?", a: "Yes. Land held in your name can be inherited via registered will or natural succession under Indian law. We can also help structure ownership for simplified transfer." },
];
